const STATS = [
  { value: "999€", label: "Pack Permis B", testid: "stat-price" },
  { value: "36", label: "Cours e-learning", testid: "stat-courses" },
  { value: "7j/7", label: "Conduite disponible", testid: "stat-hours" },
];

export default function StatsBand() {
  return (
    <section className="relative py-10 px-6 md:px-8 bg-[#f8faff]" data-testid="stats-band">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-2xl shadow-sm border border-black/5 grid grid-cols-3 divide-x divide-black/5 overflow-hidden">
          {STATS.map((s) => (
            <div key={s.testid} data-testid={s.testid} className="p-8 text-center">
              <div className="font-headings font-black text-3xl md:text-4xl text-[#00a86b] tracking-tight">{s.value}</div>
              <div className="mt-2 text-sm text-[#5b6577] font-body">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
